import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"main-banner-page\" class=\"position-relative page-header section-nav-smooth parallax blog-detail-header\" style=\"background-image:url(&#39;img/night.jpeg&#39;);\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"page-titles whitecolor text-center padding_top\"></div></div></div><div class=\"title-wrap bg-custom\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 whitecolor\"><h3 class=\"float-left\">Peraturan</h3><ul class=\"breadcrumb top10 bottom10 float-right\"><li class=\"breadcrumb-item\"><a href=\"/\">Beranda</a></li><li class=\"breadcrumb-item\">Peraturan</li></ul></div></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "our-blog",
  class: "bglight padding_top padding_bottom_half",
  style: {"background-image":"url('fe/asset/img/big-bg-white.png')","background-size":"cover","border-radius":"10px !important"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "news_item shadow-equal" }
const _hoisted_7 = {
  class: "news_desc text-center text-md-left",
  style: {"background-color":"#fff !important","background-image":"none !important"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt-0 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-dark" }, " Informasi Peraturan Kementerian Energi dan Sumber Daya Mineral ")
], -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua Kategori", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Semua Tahun", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down-fill" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_b_overlay, {
        show: _ctx.isLoading,
        rounded: "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                          class: "form-control form-control-solid w-250px ps-15",
                          placeholder: "Cari..."
                        }, null, 512), [
                          [_vModelText, _ctx.search],
                          [_directive_debounce, _ctx.searchItems, "200ms"]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("select", {
                          name: "",
                          class: "form-control",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCategoryChange($event)))
                        }, [
                          _hoisted_12,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rulesCategoryList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item.id
                            }, _toDisplayString(item.name), 9, _hoisted_13))
                          }), 128))
                        ], 32)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("select", {
                          name: "",
                          class: "form-control",
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTahunChange($event)))
                        }, [
                          _hoisted_15,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTahun, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_16))
                          }), 128))
                        ], 32)
                      ])
                    ]),
                    _createVNode(_component_Datatable, {
                      onOnSort: _ctx.sort,
                      onOnItemsPerPageChange: _ctx.itemsPerPageChange,
                      onPageChange: _ctx.pageChange,
                      data: _ctx.rulesList,
                      header: _ctx.tableHeader,
                      "enable-items-per-page-dropdown": true,
                      total: _ctx.rulesMeta.total_data,
                      itemsPerPage: 10,
                      "empty-table-text": "Tidak ada data"
                    }, {
                      id: _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(_ctx.rulesList.indexOf(row) +
                      1 +
                      (_ctx.rulesMeta.page - 1) * _ctx.rulesMeta.limit) + ". ", 1)
                      ]),
                      tahun_terbit: _withCtx(({ row: rulesList }) => [
                        _createTextVNode(_toDisplayString(rulesList.tahun_terbit), 1)
                      ]),
                      category_id: _withCtx(({ row: rulesList }) => [
                        _createTextVNode(_toDisplayString(rulesList.category.name), 1)
                      ]),
                      title: _withCtx(({ row: rulesList }) => [
                        _createTextVNode(_toDisplayString(rulesList.title), 1)
                      ]),
                      actions: _withCtx(({ row: rulesList }) => [
                        _createElementVNode("a", {
                          target: "_blank",
                          href: _ctx.getFilePath('rules-doc', rulesList.document),
                          class: "btn btn-sm btn-secondary"
                        }, [
                          _hoisted_18,
                          _createTextVNode(" Download PDF ")
                        ], 8, _hoisted_17)
                      ]),
                      _: 1
                    }, 8, ["onOnSort", "onOnItemsPerPageChange", "onPageChange", "data", "header", "total"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}